import { Component, Inject, Input, OnChanges, SimpleChanges, OnInit, ViewEncapsulation, ElementRef, ViewChild  } from "@angular/core";
import { Router, Data } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AppComponent } from "../app/app.component";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { forEach } from "@angular/router/src/utils/collection";
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, retry } from 'rxjs/operators';
import { NgbDateStruct, NgbCalendar, NgbActiveModal, NgbModal, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';

declare var google: any;
@Component({
    selector: "yourinfo",
    template: require('./yourinfo.component.html'),
    styles: [require('./yourinfo.component.css')]
})
export class YourInfoComponent implements OnChanges, OnInit {
    userInfo: FormGroup;
    report: CollisionReport;
    customerList: Array<String> = [];
    cityList: Array<String> = [];
    provinceList: Array<String> = [];
    searchtext: string = "";
    time: TimeTrack = <TimeTrack>{};
    dlmodel: DLData = <DLData>{};
    date: Date = new Date();
    year1: any;
    year2: any;
    year3: any;
    year4: any;
    accidentdate: Date = new Date();
    CollisionYear: any;
    CollisionMonth: any;
    CollisionDay: any;
    InsCollisionYear: any;
    InsCollisionMonth: any;
    InsCollisionDay: any;

    DOBYear: any;
    DOBMonth: any;
    DOBDay: any;
    years: any;

    preventCityClear: boolean;
    preventInsuranceClear: boolean;

    constructor(private appcomponent: AppComponent, private http: HttpClient, @Inject('BASE_URL') private baseUrl: string,
        private router: Router, private formBuilder: FormBuilder, private calendar: NgbCalendar,
        private modalService: NgbModal) {
        this.report = appcomponent.getReport();
        this.preventCityClear = false;
        this.preventInsuranceClear = false;
        if (this.report.CollisionReportUniqueId == null) {
            this.reportGetSync();
            this.router.navigate([this.router.url])
        }

        this.userInfo = this.formBuilder.group({
            firstName: ['', [Validators.required]],
        })
        this.baseUrl = appcomponent.getBaseUrl();

        this.DOBYear = ""; // Default selection to "Year"
        this.DOBMonth = ""; // Default selection to "Month"
        this.DOBDay = ""; // Default selection to "Day"

        this.CollisionYear = ""; // Default selection to "Year"
        this.CollisionMonth = ""; // Default selection to "Month"
        this.CollisionDay = ""; // Default selection to "Day"

        this.InsCollisionYear = ""; // Default selection to "Year"
        this.InsCollisionMonth = ""; // Default selection to "Month"
        this.InsCollisionDay = ""; // Default selection to "Day"

        //Default the vehicle plate to ontario
        this.report.VehiclePlateProvince = "ONTARIO";

        //To scroll to top of the page
        document.body.scrollTop = 0;

        var year = this.date.getFullYear();
        this.year1 = (year - 1).toString();
        this.year2 = year.toString();
        this.year3 = (year + 1).toString();
        this.year4 = (year + 2).toString();


        if (this.report.CollisionDate != null) {
            //2019-05-17T04:00:00Z

            var accdate = this.report.CollisionDate.toString()
            //alert("Collision date: " + this.report.CollisionDate.toString());

            var Accyear = accdate.substring(0, 4);
            var AccMonth = accdate.substring(5, 7);
            var Accday = accdate.substring(8, 10);

            if (Accyear == this.year1) {
                //set to year 1
                this.CollisionYear = 1;
            }
            if (Accyear == this.year2) {
                //set to year2
                this.CollisionYear = 2
            }
            if (Accyear == this.year3) {
                //set to year3
                this.CollisionYear = 3
            }

            this.CollisionMonth = AccMonth
            this.CollisionDay = Accday
        }

        //Showing the DOB if it exists
        if (this.report.DOB != null) {
            var dob = this.report.DOB.toString();

            var dobYear = dob.substring(0, 4);
            var dobMonth = dob.substring(5, 7);
            var dobday = dob.substring(8, 10);

            this.DOBYear = dobYear;
            this.DOBMonth = dobMonth;
            this.DOBDay = dobday;
        }

        if (this.report.InsuranceExpiryDate != null) {
            var ied = this.report.InsuranceExpiryDate.toString();

            var y = ied.substring(0, 4);
            var m = ied.substring(5, 7);
            var d = ied.substring(8, 10);

            if (y == this.year2) {
                this.InsCollisionYear = "1";
            }
            if (y == this.year3) {
                this.InsCollisionYear = "2";
            }
            if (y == this.year4) {
                this.InsCollisionYear = "3";
            }

            this.InsCollisionMonth = m;
            this.InsCollisionDay = d;
        }

        //DOB
        var year = this.date.getFullYear();
        var range = [];

        range.push(year-101);

        for (var i = 100; i > 1; i--) {
            range.push(year - i)
        }

        this.years = range;
    }

    

    validateDOB() {

        if (this.DOBYear == "" || this.DOBYear == "Year") {
            alert("DOB Year cannot be empty");
            return false;
        }
        if (this.DOBMonth == "" || this.DOBMonth == "Month") {
            alert("DOB Month cannot be empty");
            return false;
        }
        if (this.DOBDay == "" || this.DOBMonth == "Day") {
            alert("DOB Day cannot be empty");
            return false;
        }

        var year = this.DOBYear;
        var month = this.DOBMonth;
        var day = this.DOBDay;

        //Year already a string. It is from an array. 
        //alert("year: " + year + " month: " + month + " day: " + day);

        var datestring = year + '/' + month.toString() + '/' + day.toString();
        var timestring = '00:00:00';
        var newdate = new Date(datestring + ' ' + timestring);

        if (newdate > this.date) {
            alert("Please provide valid DOB");
            return false;
        }
        
        //Set DOB
        this.report.DOB = newdate;

        return true;
    }

    public getInsuranceCompany(): string {
        return this.report.DriverInsuranceCompany.toString();
    }

    getAccidentDate(): void {
        var month = this.report.CollisionDate.getMonth().toString();
        var day = this.report.CollisionDate.getDay().toString();
        this.CollisionDay = day.toString();
        this.CollisionMonth = month.toString();
    }

    onPlateInput(): void {
        var v = this.report.VehiclePlate.replace(/\s/, '').replace('_', '').replace(/\W/g, '');
        this.report.VehiclePlate = v
    }

    onPhoneInput(): void {
        var phone = this.report.PrimaryPhoneNumber.replace(/[^0-9]/g, "");
        var v = phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        this.report.PrimaryPhoneNumber = v;
    }

    onPhoneInput1(): void {
        var phone = this.report.CustomerPhone.replace(/[^0-9]/g, "");
        var v = phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        this.report.CustomerPhone = v;
    }

    checkPhoneValid(): boolean {
        let regrxp: RegExp = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/

        if (regrxp.test(this.report.PrimaryPhoneNumber)) {
            alert("Please enter valid ")
            return false
        }
        return true
    }

    openVerticallyCentered(content: any) {
        this.modalService.open(content, { centered: true });
    }

    ngOnInit() {

    }

    ngAfterViewInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (typeof changes['report'] !== "undefined") {
            // retrieve the report variable change info
            var change = changes['report'];
            // only perform the task if the value has been changed
            if (!change.isFirstChange()) {
                // execute the Http request and retrieve the result
            }
        }
        else
            console.log("Undefined");
    }

    onBack(): void {
        this.BackAndPost("email");
    }

    private BackAndPost(page: string): void {
        this.report.CurrentPage = page;
        this.router.navigate([page]);
    }

    onSubmit(): void {

        if (this.report.EntityType != null && (this.report.EntityType == "PEDESTRIAN" || this.report.EntityType == "CYCLIST")) {
            this.ValidateAndPost("prequalification");
        }
        //else
        //    this.ValidateAndPost("prequalificationdriver");
    }

    private ValidateAndPost(page: string) {
        if (this.IsValid()) {
            this.report.IsYourInfoPageValid = true;
            this.report.CurrentPage = page;
            this.appcomponent.setReport(this.report);

            //GO TO NEXT PAGE
            this.router.navigate([page]);
        }
    }

    private IsValid(): boolean {
        var DOB = this.validateDOB();
        var CollDate = this.ValidateCollisionDate();
        var InsDate = this.ValidateInsuranceExpiry();

        if (CollDate && InsDate && DOB) {
            return true;
        }
        else {
            return false;
        }
    }

    ValidateCollisionDate(): boolean {
        if (this.CollisionYear == "" || this.CollisionYear == "Year") {
            alert("Collision Year cannot be empty");
            return false;
        }
        if (this.CollisionMonth == "" || this.CollisionMonth == "Month") {
            alert("Collision Month cannot be empty");
            return false;
        }
        if (this.CollisionDay == "" || this.CollisionDay == "Day") {
            alert("Collision Day cannot be empty");
            return false;
        }
        if (this.report.CollisionHour == null) {
            alert("Collision Hour cannot be empty");
            return false;
        }
        if (this.report.CollisionMinute == null) {
            alert("Collision Minute cannot be empty");
            return false;
        }

        var year = this.CollisionYear

        if (year == 1) {
            year = this.date.getFullYear() - 1
        }
        else if (year == 2) {
            year = this.date.getFullYear()
        }
        else if (year == 3) {
            year = this.date.getFullYear() + 1
        }

        var month = this.CollisionMonth
        var day = this.CollisionDay

        var hour = this.report.CollisionHour;
        var min = this.report.CollisionMinute;

        //alert("year: " + year + " month: " + month + " day: " + day);

        var datestring = year.toString() + '/' + month.toString() + '/' + day.toString();
        var timestring = hour + ':' + min + ':00';
        var accdate = new Date(datestring + ' ' + timestring);

        var oldTimestamp = this.date.getTime() - (50 * 24 * 60 * 60 * 1000);

        if (accdate > this.date) {

            alert("Please provide a valid date and time for the accident.");
            return false;
        }
        else if (accdate.getTime() < oldTimestamp) {

            alert("You should report within 50 days of the accident.");
            return false;
        }

        if (this.report.NumberOfVehicleInvolved == null || this.report.NumberOfVehicleInvolved == 0) {
            alert("Please enter the number of parties involved.");
            return false;
        }

        //Set Accident Date
        this.report.CollisionDate = accdate;

        return true;
    }

    ValidateInsuranceExpiry(): boolean {
        var year = this.InsCollisionYear

        if (year == 1) {
            year = this.date.getFullYear()
        }
        else if (year == 2) {
            year = this.date.getFullYear() + 1
        }
        else if (year == 3) {
            year = this.date.getFullYear() + 2
        }

        var month = this.InsCollisionMonth;
        var day = this.InsCollisionDay;

        if (!year || !month || !day) {
            return true;
        }
        else {
            //alert("year: " + year + " month: " + month + " day: " + day);

            var datestring = year.toString() + '/' + month.toString() + '/' + day.toString();
            var timestring = '00:00:00';
            var insdate = new Date(datestring + ' ' + timestring);

            this.report.InsuranceExpiryDate = insdate;

            if (insdate <= this.report.CollisionDate) {
                alert("Please enter valid Insurance Expiry Date");
                return false;
            }
            else {
                return true;
            }
        }
    }

    validateDL(value: string): void {
        var url = this.baseUrl + "api/DL";
        var data: DriversLicenceInformation;

        this.dlmodel.DlString = value;
        this.dlmodel.Id=123;
        this.http
            .post(url, this.dlmodel)
            .subscribe(res => {
                data = res as DriversLicenceInformation;
                if (data != null) {
                    this.report.DriverLicense = data.DriversLicenceNumber;
                    this.report.DriverLicenceClass = data.Class;
                    if (data.DateOfBirth != null) {
                        this.report.DOB = data.DateOfBirth;
                    }
                    this.report.Firstname = data.FirstName;
                    this.report.Lastname = data.LastName;
                    this.report.Address = data.Address;
                    this.report.City = data.DriversLicenceCity;
                    if (data.Sex != null) {
                        if (data.Sex=="1") //Changed from 1 to 2 // Changed again - realized that the mistake is in the json file
                            this.report.Gender = "M";
                        else
                            this.report.Gender = "F";
                    }
                    else
                        this.report.Gender = "M";

                    if (data.RawProvince != null) {
                        this.report.City = this.report.City + ", " + data.RawProvince;
                    }

                    this.report.PostalCode = data.PostalCode;
                    this.modalService.dismissAll();
                }
            }, error => console.log(error));
    }

    onEntityTypeChange(entity: string): void {
        this.report.EntityType = entity;
    }

    setToday(): void {

    }
    setYesterday(): void {

    }

    //Insurance autocomplete fixes
    selectedDriverInsuranceCompany(event: any) {
        this.preventInsuranceClear = true;
        this.report.DriverInsuranceCompany = event.item;
    }

    clearDriverInsuranceCompany() {
        this.report.DriverInsuranceCompany = "";
    }

    blurDriverInsuranceCompany() {
        if (this.report.DriverInsuranceCompany != null && this.report.DriverInsuranceCompany != '' && !this.preventInsuranceClear) {
            this.clearDriverInsuranceCompany();
        }
        else if (this.report.DriverInsuranceCompany == null || this.report.DriverInsuranceCompany == '') {
            setTimeout(() => {
                if (document.getElementById("DriverInsuranceCompany") != null)
                (<HTMLInputElement>document.getElementById("DriverInsuranceCompany")).value = '';
            }, 100);
        }
        else {
            this.preventInsuranceClear = false;
        }
    }

    //City autocomplete fixes
    selectedCity(event: any) {
        this.preventCityClear = true;
        this.report.City = event.item;
    }

    clearCity() {
        this.report.City = "";
    }

    blurCity() {
        if (this.report.City != null && this.report.City != '' && !this.preventCityClear) {
            this.clearCity();
        }
        else if (this.report.City == null || this.report.City == '') {
            setTimeout(() => {
                if (document.getElementById("City") != null)
                    (<HTMLInputElement>document.getElementById("City")).value = '';
            }, 100);
        }
        else {
            this.preventCityClear = false;
        }
    }

    //validateInsuranceCompany() {
    //    setTimeout(() => {
    //    console.log("Validating ins");
    //    this.validating = true;
    //    this.validateInsurancePromise().then(result => {
    //        console.log("Result");
    //        console.log(result);
    //        if (result == false) {
    //            setTimeout(() => {
    //                console.log("Making ins empty");
    //                this.report.DriverInsuranceCompany = "";
    //                console.log(this.report.DriverInsuranceCompany); } ,250)
                
    //        }
    //    }).catch(result => { this.report.DriverInsuranceCompany = ""; });
    //    }, 250);
    //}

    //validateInsurancePromise(): Promise<boolean> {
    //    var url = this.baseUrl + "api/report/ValidateCustomer/" + this.report.DriverInsuranceCompany;
    //    return this.http
    //        .post(url, {})
    //        .toPromise().then(res => {
    //            this.validating = false;
    //            var result = res as boolean;
    //            return result;
    //        }, error => {
    //            console.log(error);
    //            this.validating = false;
    //            return false;
    //        });
    //}

    setAMPM(value: string): void {
        this.report.AMPM = value;
    }

    searchInsurance = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => term.length < 2 ? []
                : this.getInsuranceData(term))
        );

    getInsuranceData(term: string): Array<String> {
        var url = this.baseUrl + "api/report/Customer/" + term;
        var data: any;
        this.http
            .get(url)
            .subscribe(res => {
                data = res as string[];
                for (let i = 0; i < data.length; i++) {
                    this.customerList.push(data[i]);
                }
            }, error => console.log(error));

        if (data == null) {
            this.customerList.push("Not Found");
        }

        return Array.from(new Set(this.customerList)).filter(item =>
            item.toLowerCase().includes(term.toLowerCase()));
    }

    searchCity = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => term.length < 2 ? []
                : this.searchCityData(term))
        );

    searchCityData(term: string): Array<String> {
        var url = this.baseUrl + "api/report/City/" + term;
        var data: any;
        this.http
            .get(url)
            .subscribe(res => {
                data = res as string[];
                for (let i = 0; i < data.length; i++) {
                    this.cityList.push(data[i]);
                }
            }, error => console.log(error));

        if (data == null) {
            this.cityList.push("Not Found");
        }

        return Array.from(new Set(this.cityList)).filter(item =>
            item.toLowerCase().includes(term.toLowerCase()));
    }

    searchPlateProvince = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => term.length < 2 ? []
                : this.searchPlateProvinceData(term))
        );

    searchPlateProvinceData(term: string): Array<String> {
        var url = this.baseUrl + "api/report/Province/" + term;
        var data: any;
        this.http
            .get(url)
            .subscribe(res => {
                data = res as string[];
                for (let i = 0; i < data.length; i++) {
                    this.provinceList.push(data[i]);
                }
            }, error => console.log(error));

        if (data == null) {
            this.provinceList.push("Not Found");
        }

        return Array.from(new Set(this.provinceList)).filter(item =>
            item.toLowerCase().includes(term.toLowerCase()));
    }

    findChoicesInsurance(customerList: Array<String>) {
        return (searchText: any) => {
            var url = this.baseUrl + "api/report/City/" + this.searchtext;
            var data: any;
            this.http
                .get(url)
                .subscribe(res => {
                    data = res as string[];
                    for (let i = 0; i < data.length; i++) {
                        customerList.push(data[i]);
                    }
                }, error => console.log(error));

            if (data == null) {
                customerList.push("Not Found");
            }

            return Array.from(new Set(customerList)).filter(item =>
                item.toLowerCase().includes(searchText.toLowerCase()));
        };
    }

    getChoiceLabelInsurance(choice: string) {
        return choice;
    }

    findChoicesCity(cityList: Array<String>) {
        return (searchText: any) => {
            var url = this.baseUrl + "api/report/City/" + searchText;
            var data: any;
            this.http
                .get(url)
                .subscribe(res => {
                    data = res as string[];
                    for (let i = 0; i < data.length; i++) {
                        cityList.push(data[i]);
                    }
                }, error => console.log(error));

            if (data == null) {
                cityList.push("Not Found");
            }

            return Array.from(new Set(cityList)).filter(item =>
                item.toLowerCase().includes(searchText.toLowerCase()));
        };
    }

    getChoiceLabelCity(choice: string) {
        return choice;
    }


    checkEntityTypePedestrian(): boolean {
        if (this.report.EntityType != null && this.report.EntityType == "PEDESTRIAN") {
            return true;
        }
        return false;
    }

    checkEntityTypeCyclist(): boolean {
        if (this.report.EntityType != null && this.report.EntityType == "CYCLIST") {
            return true;
        }
        return false;
    }

    reportGetSync(): void {
        var url = this.baseUrl + "api/report";
        this.http
            .get(url)
            .toPromise().then(result => {
                var v = result as CollisionReport;
                if (typeof v.EntityType == 'undefined' || v.EntityType == null || v.EntityType == "") {
                    this.router.navigate(["home"]);
                }
                this.report = v;
            });
    }
}